document.addEventListener('DOMContentLoaded', function() {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  const banner = document.getElementById('sticky-header');
  const header = document.querySelector('header.shopify-section--header');
  if (!banner || !header) return;

  const headerHeight = header.offsetHeight;
  window.addEventListener('scroll', () => {
    if (window.scrollY > headerHeight) {
      banner.classList.add('active');
      banner.style.display = 'flex';    // ← ここで直接表示
    } else {
      banner.classList.remove('active');
      banner.style.display = 'none';    // ← ここで直接非表示
    }
  });
});
